import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  careList: [],
  carePagination: {},
  careDetail: {},
  error: null,
  slotDashboard: {},
  deleteCareSuccess: false,
};

const directCareSlice = createSlice({
  name: "directCareCare",
  initialState,
  reducers: {
    careListLoad(state) {
      state.isLoading = true;
      state.addCareSuccess = false;
      state.deleteCareSuccess = false;
    },
    careListSuccess(state, action) {
      const { list = [], pagination = {}, slotDashboard = {} } = action.payload;
      state.isLoading = false;
      state.careList = list;
      state.carePagination = pagination;
      state.slotDashboard = slotDashboard;
    },
    careListFail(state) {
      state.isLoading = false;
      state.error = true;
    },

    deleteCareLoad(state) {
      state.isLoading = true;
      state.deleteCareSuccess = false;
    },

    deleteCareSuccess(state) {
      state.isLoading = false;
      state.deleteCareSuccess = true;
    },

    deleteCareFail(state) {
      state.isLoading = false;
      state.error = true;
    },

    clearCareSuccessFlags(state) {
      state.addCareSuccess = false;
      state.deleteCareSuccess = false;
    },
  },
});

export const {
  careListLoad,
  careListSuccess,
  careListFail,

  deleteCareLoad,
  deleteCareSuccess,
  deleteCareFail,
} = directCareSlice.actions;

export default directCareSlice.reducer;
